<template>
	<label class="flex items-center relative w-full">
		<form-input :placeholder="str.placeholder" v-model="search" @focus="display = true" @blur="display = false" @keyup="display = true">
			<!-- <template v-slot:icon><i class="fas fa-fw" :class="str.icon"></i></template> -->
		</form-input>
		<div
			v-if="display && search?.length > 0"
			class="absolute bottom-0 left-0 w-full focus:flex flex-col justify-between translate-y-full pt-2 z-50">
			<TransitionGroup
				tag="ul"
				v-if="results?.length > 0"
				class="max-h-96 overflow-y-auto grid grid-cols-1 divide-y bg-slate-50 rounded-md hover:shadow-md text-slate-500 border border-slate-800 overflow-x-hidden"
				appear>
				<li v-for="item in results" :key="item.id" @click="itemSelected(item)">
					<div v-if="!excludedIds.includes(item.id)" class="flex gap-2 text-blue-400 cursor-pointer p-2 hover:text-blue-500 items-center">
						<i class="far fa-user" v-if="item.model_type == 'contact'"></i>
						<i class="far fa-hospital" v-if="item.model_type == 'structure'"></i>
						{{ item.first_name || item.name }}
						{{ item.last_name }}
						<span v-if="item.targeted" class="rounded text-blue-500 p-1">
							<i class="fas fa-crosshairs"></i>
						</span>
					</div>
				</li>
			</TransitionGroup>
			<ui-alert v-if="results?.length == 0 && !loading">Aucun résultat</ui-alert>
		</div>
	</label>
</template>

<script setup>
	import { ref, computed, watch } from 'vue';
	import debounce from 'lodash.debounce';

	const props = defineProps({
		type: {
			type: String,
			default: 'all',
		},
		replaceOnSelect: {
			type: Boolean,
			default: false,
		},
		history: {
			type: Boolean,
			default: false,
		},
		excludedIds: {
			type: Array,
			default: () => [],
		},
	});

	const emit = defineEmits(['select']);

	const search = ref('');
	const display = ref(false);
	const loading = ref(false);
	const results = ref([]);

	const str = computed(() => {
		if (props.type == 'contact') {
			return {
				placeholder: 'Rechercher un contact',
				icon: 'fa-user',
			};
		}
		if (props.type == 'structure') {
			return {
				placeholder: 'Rechercher une structure',
				icon: 'fa-hospital',
			};
		}
		return {
			placeholder: 'Recherche',
			icon: 'fa-search',
		};
	});

	const doSearch = debounce(async () => {
		if (search.value?.length <= 0) {
			loading.value = false;
			return;
		}
		loading.value = true;
		try {
			const response = await window.axios.post(route('home.search'), {
				item: search.value,
				type: props.type,
				history: props.history,
			});
			results.value = response.data;
		} finally {
			loading.value = false;
		}
	}, 400);

	watch(search, () => {
		loading.value = true;
		doSearch();
	});

	const itemSelected = (item) => {
		emit('select', item);
		display.value = false;
		if (props.replaceOnSelect) {
			if (item.model_type == 'structure') {
				search.value = item.name;
			}
			if (item.model_type == 'contact') {
				search.value = `${item.first_name} ${item.last_name}`;
			}
		}
	};
</script>
